module.exports = ".form-check-label{\r\n    color: black;\r\n    font-weight: 500;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/User/feedback/feedback.component.css
// module id = ./src/app/Pages/User/feedback/feedback.component.css
// module chunks = main